import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './ar-w4.component.html';
import "./ar-w4.component.less";
import { SignaturePadModal } from '../signature/signature-pad.component';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import moment from 'moment';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const ArW4Component = {
    templateUrl,
    controller: Arw4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function Arw4Controller(onboardingActionPolicy, onboardingDocumentService, $uibModal, $state, $scope, $q, utilityService, employeeService, onboardingDocumentViewService, stateProvinceService, localeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';

    vm.arw4Form;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onSubmit = onSubmit;
    vm.cancel = cancel;
    vm.onSign = onSign;
    vm.onDocDownload = onDocDownload;
    vm.onClose = onClose;
    vm.onSave = onSave;
    vm.stateProvinces;
    vm.updateTaxRates = updateTaxRates;
    vm.updateExemptions = updateExemptions;
    vm.onEditClicked = onEditClicked;
    vm.enabledExemption = '';
    vm.onShowI9 = onShowI9;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onRequestReview = onRequestReview;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;

    vm.state = {
        view: 'W4'
    };
    vm.reqReview = false;
    vm.isSaved = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.showSavedNotification = false;
    vm.savedData = false;
    vm.disableEmpFields = true;

    vm.previewUrl;
    vm.maritalStatusMapping = [
        { id: 4, status: 'S' },
        { id: 5, status: 'MJ' },
        { id: 6, status: 'H' }];

    vm.$onInit = function () {
        console.log(vm.resolve);
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'DD/MM/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;
        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });

        if (vm.savedInputs != null && vm.savedInputs.EmployeeFirstNameMiddleInitialLastName != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            //default to user profile
            vm.employeeName = this.employeeProfile.FullName;
            vm.employeeSsn = this.employeeBankInfo.CurrentSSN;
            vm.address = this.profile.HomeAddress?.StreetLine1;
            vm.city = this.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = this.profile.HomeAddress.PostalCode;
        } else if (vm.userInputs != null && vm.userInputs.EmployeeFirstNameMiddleInitialLastName != null) {
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            //prefill this.userInputs
            fillEmployee(vm.userInputs);
        } else {
            //prefill user info
            vm.employeeName = this.employeeProfile.FullName;
            vm.employeeSsn = this.employeeBankInfo.CurrentSSN;
            vm.address = this.profile.HomeAddress?.StreetLine1;
            vm.city = this.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = this.profile.HomeAddress.PostalCode;
            //if (vm.employeeBankInfo?.MaritalStatusID) {
            //    vm.filingStatus = vm.maritalStatusMapping.reduce(function (result, item, index) {
            //        if (item.id === vm.employeeBankInfo?.MaritalStatusID) {
            //            result = item.status;
            //        }
            //        return result;
            //    }, null)
            //}
            console.log(vm.filingStatus);
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        vm.editable = resolveEditable();
        

    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;  // ? ProvinceW4

        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        return !vm.application.HasSW4Form              // ? HasSW4Form
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }
    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending') {
            vm.employeeName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
    }
    ////event to track if user changed any form data
    //$scope.$watch(() => angular.toJson(vm.arW4Form), function (newVal, oldVal) {
    //    if (newVal !== oldVal) {
    //        vm.ISPreview = false;
    //    }
    //}, true);

    $scope.$watch('vm.arW4Form.$dirty', function (value) {
        // This is how we tell if there are unsaved form changes so we don't navigate away
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function onSign() {
        return $uibModal.open({
            ...SignaturePadModal,
            resolve: {
                title: () => "Changes to Time Entry"
            }
        }).result.then(function (data) {
            vm.signimage = data;
        });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }


    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.arW4Form && vm.arW4Form.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onShowFederalW4() {
        if (vm.ownerView) {
            return $state.go('application-status.ownermodal.federalW4');
        }
        //warning for pending changes
        if (vm.arW4Form && vm.arW4Form.$dirty) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "onboarding-document.federalW4";
                    }
                },
                size: 'sm',
                backdrop: 'static'
            }).result
        }
        return $state.go('onboarding-document.federalW4');
    }

    //function onShowFederalW4Signature() {
    //    if (vm.ownerView) {
    //        return $state.go('application-status.ownermodal.federalW4');
    //    }
    //    return $state.go('onboarding-document.federalW4Signature');
    //}

    function fillEmployee(data) {
        vm.employeeName = data.EmployeeFirstNameMiddleInitialLastName;
        vm.employeeSsn = data.EmployeeSocialSecurityNumber;
        vm.address = data.EmployeeStreetAddress1StreetAddress2;
        vm.city = data.EmployeeCity;
        vm.stateProvince = vm.stateProvinces.find(x => x.Abbr === data.EmployeeState);
        vm.zipCode = data.EmployeeZip;
        vm.exemptionCheckbox = data.ExemptionCheckbox;
        vm.personalExemption = data.PersonalExemption;
        vm.marriedExemption = data.MarriedExemption;
        vm.headOfHouseholdExemption = data.HeadOfHouseholdExemption;
        vm.dependents = data.Dependents;
        vm.additionalStateWithholding = data.AdditionalStateWithholding;
        vm.totalExemptions = data.TotalAllowances;

        vm.date = moment(data.Date, 'DD/MM/YYYY').toDate();

        vm.lowIncomeTaxRates = data.LowIncomeTaxRates;
        if (vm.lowIncomeTaxRates === 'true') {
            vm.filingStatus = data.FilingStatus;
        }
        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;

        }
        vm.prefilled = true;
    }

    function updateExemptions() {
        //if (!vm.exemptionCheckbox) {
        //    vm.arW4Form.exemptionCheckbox.$setValidity('required', true);
        //}
        if (vm.exemptionCheckbox === 'S1') {
            /*vm.personalExemption = 1;*/
            vm.marriedExemption = '';
            vm.headOfHouseholdExemption = '';
            //vm.totalExemptions = parseInt(vm.dependents) + 1;
            // vm.filingStatus = 'S'
        } else if (vm.exemptionCheckbox === 'M2') {
            vm.personalExemption = '';
            //vm.marriedExemption = '2';
            vm.headOfHouseholdExemption = '';
            //vm.totalExemptions = parseInt(vm.dependents) + 2;
            //vm.filingStatus = 'MJ'
        } else if (vm.exemptionCheckbox === 'H2') {
            vm.personalExemption = '';
            vm.marriedExemption = '';
            //vm.headOfHouseholdExemption = '2';
            //vm.totalExemptions = parseInt(vm.dependents) + 2;
            //vm.filingStatus = 'H'
        }
    }

    function updateTaxRates(taxrate) {
        if (taxrate === 'true') {

        } else {
            vm.filingStatus = null;
        }
    }

    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', '6', pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });

    }

    function onPreview() {

        if (vm.arW4Form && vm.arW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            Personalexemption: vm.personalExemption,
            Marriedexemption: vm.marriedExemption,
            Headofhouseholdexemption: vm.headOfHouseholdExemption,
            Dependents: vm.dependents,
            AdditionalStateWithholding: vm.additionalStateWithholding,
            Totalallowances: vm.totalExemptions,
            Exemptioncheckbox: vm.exemptionCheckbox,
            Date: moment(vm.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            Signature: vm.signimage,
            Filingstatus: vm.filingStatus,
            Lowincometaxrates: vm.lowIncomeTaxRates
        };
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 6).then(function (result) {
            utilityService.hideLoading();
            vm.previewUrl = result;
            return $uibModal.open({
                ...OwnerPreviewSignatureModal,
                resolve: {
                    title: () => "AR-W4 Preview",
                    previewUrl: () => {
                        return vm.previewUrl;
                    },
                    allowApprove: () => {
                        return canApproveForm(vm.application, '2');
                    },
                    allowSign: () => {
                        return false;
                    }, //for pages without signature
                    showSignaturePopup: () => {
                        return vm.showSignaturePopup;
                    }
                }
            }).result;
        }).then(function (data) {
            console.log(data);
            if (data === 'ok') {
                vm.employerSignimage = data.dataUrl;
                vm.isSigned = true; //employer version
                return onSubmit();
            }
        }).catch((err) => {
            console.log(err);
            utilityService.hideLoading();
        });
        //return onboardingDocumentService.preview(vm.employee.UserName, formData, 6).then(function (result) {
        //    utilityService.hideLoading();
        //    vm.ISPreview = true;
        //    return result;
        //}).then(function () {
        //    utilityService.hideLoading();
        //});


    }

    function onPreviewInPage() {

        if (vm.arW4Form && vm.arW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }

        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            Personalexemption: vm.personalExemption,
            Marriedexemption: vm.marriedExemption,
            Headofhouseholdexemption: vm.headOfHouseholdExemption,
            Dependents: vm.dependents,
            AdditionalStateWithholding: vm.additionalStateWithholding,
            Totalallowances: vm.totalExemptions,
            Exemptioncheckbox: vm.exemptionCheckbox,
            Date: moment(vm.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            FilingStatus: vm.filingStatus,
            LowIncomeTaxRates: vm.lowIncomeTaxRates
        };
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 6).then(function (result) {
            utilityService.hideLoading();
            vm.previewUrl = result;
            return $uibModal.open({
                ...PreviewSignatureModal,
                resolve: {
                    title: () => "Federal-W4 Preview",
                    previewUrl: () => {
                        return vm.previewUrl;
                    }
                }
            }).result;
        }).then(function (data) {
            console.log(data);
            vm.signimage = data.dataUrl;
            vm.isSigned = data.dataUrl != null;
            return onSubmit();
        }).catch((err) => {
            console.log(err);
            utilityService.hideLoading();
        });


    }

    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            Personalexemption: vm.personalExemption,
            Marriedexemption: vm.marriedExemption,
            Headofhouseholdexemption: vm.headOfHouseholdExemption,
            Dependents: vm.dependents,
            AdditionalStateWithholding: vm.additionalStateWithholding,
            Totalallowances: vm.totalExemptions,
            Exemptioncheckbox: vm.exemptionCheckbox,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            Signature: vm.signimage,
            Filingstatus: vm.filingStatus,
            Lowincometaxrates: vm.lowIncomeTaxRates
        };
        return onboardingDocumentService.save(vm.employee.UserName, formData, '6').then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.arW4Form.$setPristine();
            return utilityService.hideLoading();
        });
    }

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    function onSubmit() {
        
        if (vm.arW4Form && vm.arW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return utilityService.hideLoading();
        }
        let updatePromises = [];
        let submitApplicationPromise = $q.defer();
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.arW4Form && vm.arW4Form.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
                return;
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            let formData = {
                RequestTypeId: '2',
                EmployeeFirstnameMiddleinitialLastname: vm.employeeName,
                EmployeeSocialsecuritynumber: vm.employeeSsn,
                EmployeeStreetaddress1Streetaddress2: vm.address,
                EmployeeCity: vm.city,
                EmployeeState: vm.stateProvince.Abbr,
                EmployeeZip: vm.zipCode,
                Personalexemption: vm.personalExemption,
                Marriedexemption: vm.marriedExemption,
                Headofhouseholdexemption: vm.headOfHouseholdExemption,
                Dependents: vm.dependents,
                AdditionalStateWithholding: vm.additionalStateWithholding,
                Totalallowances: vm.totalExemptions,
                Exemptioncheckbox: vm.exemptionCheckbox,
                Date: moment(vm.date, 'MM/DD/YYYY').format('DD/MM/YYYY'),
                Signature: vm.signimage,
                Filingstatus: vm.filingStatus,
                Lowincometaxrates: vm.lowIncomeTaxRates
            };
            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, 6);
            updatePromises.push(submitApplicationPromise);
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }

        const trans = $q.all(updatePromises).then((res) => {
            if (res) {
                if (vm.ownerView) {
                    return onApprove();
                } else {
                    return onShowI9();
                }
            }
        }).catch((err) => {
            utilityService.hideLoading();
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }


    function cancel() {
        //vm.taxForm = {};
        vm.arw4Form.$setPristine(true);
        vm.resetRequestType();
    }
}


export const ARW4Modal = {
    component: "apexARW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}

